import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

export const LANGS = [
  { id: "lv", label: "LV" },
  { id: "en", label: "EN" },
  { id: "ru", label: "RU" },
];

const ru = {
  nav: { products: "Модели", order: "Конструктор", how: "Как заказать", faq: "Вопросы", contacts: "Контакты", buy: "Купить", build: "Собрать рамку", openMenu: "Открыть меню", language: "Язык" },
  hero: {
    badge: "RPM 3D PRINT · НОМЕРНЫЕ РАМКИ",
    title1: "Номерные рамки",
    title2: "с вашим",
    title3: "текстом",
    sub: "Печатаем на 3D-принтере под вашу машину: ваш текст снизу рамки, цвет на выбор. Соберите рамку за минуту, оплатите картой — и получите в пакомате Omniva.",
    cta: "Собрать свою рамку",
    cta2: "Смотреть модели",
    f1: "от 12 €", f1s: "2 шт. — 22 €",
    f2: "Картой", f2s: "онлайн-оплата",
    f3: "3,50 €", f3s: "пакомат Omniva",
    extruder: "ЭКСТРУДЕР", layer: "СЛОЙ",
    marquee: ["ИНДИВИДУАЛЬНЫЙ ТЕКСТ", "2 ШТ. — 22 €", "3D-ПЕЧАТЬ", "БЕЛЫЙ · СИНИЙ · РОЗОВЫЙ · КРАСНЫЙ", "ПАКОМАТ OMNIVA", "ОПЛАТА КАРТОЙ", "RPM 3D PRINT"],
  },
  products: {
    label: "01 — Модели", title: "Выберите свой вариант",
    sub: "Каждую рамку печатаем под заказ — именно с тем текстом, который вы напишете.",
    badge: "С вашим текстом", order: "Заказать от {price}", orderFor: "Заказать за {price}", photo: "Фото", preview: "Превью",
    pairDeal: "2 шт. — {price}", pairSave: "выгода {save}", packNote: "за 2 комплекта",
    items: {
      individual: { local: "Индивидуальная номерная рамка", description: "Ваш текст снизу рамки, цвет текста на выбор. Печатаем под заказ. 1 шт. — 12 €, 2 шт. — 22 €.", features: ["Ваш текст снизу рамки", "4 цвета текста", "Скидка: 2 шт. за 22 €"] },
      invisible: { local: "Невидимые держатели номера — 2 комплекта", description: "В наборе 2 комплекта: один для больших номеров, второй для маленьких — в Латвии номера бывают двух размеров. Каждый комплект рассчитан на 2 номера.", features: ["2 комплекта: для больших и для маленьких номеров", "Каждый комплект — на 2 номера", "Номер будто «парит», простая установка"] },
    },
  },
  config: {
    label: "02 — Конструктор", title: "Соберите свою рамку",
    sub: "Пишите текст — рамка меняется сразу. Именно так мы её и напечатаем.",
    preview: "Превью · live", previewNote: "Превью схематичное. Шрифт и пропорции на готовой рамке могут немного отличаться.",
    pcs: "шт.", textColor: "текст",
    step1: "Модель", step2: "Текст на рамке", step2hint: "Текст печатается снизу номера",
    bottom: "Текст снизу", bottomPh: "Например: @your_instagram",
    ideas: "Идеи — нажмите, чтобы подставить:", ideaList: ["TI CHO APUPEL", "RPM 3D PRINT", "LATVIJA", "RĪGA", "НЕ СИГНАЛЬ", "LOW & SLOW", "JDM", "DRIVE SAFE"],
    textError: "Напишите текст для нижней части рамки",
    step3: "Цвет текста", step4: "Количество", step4hint: "Обычно берут 2 — спереди и сзади: 22 € вместо 24 €",
    step4Pack: "Количество наборов", step4PackHint: "1 набор = 2 комплекта: для больших и для маленьких номеров, каждый на 2 номера", packs: "наб.",
    add: "Добавить в заказ", added: "Добавлено в заказ", maxItems: "Максимум 10 позиций в одном заказе",
    less: "Меньше", more: "Больше",
    holderHidden: "ДЕРЖАТЕЛЬ СКРЫТ ЗА НОМЕРОМ",
  },
  checkout: {
    delivery: "Доставка", free: "Бесплатно",
    locker: "Пакомат Omniva", lockerChoose: "Выбрать пакомат", lockerChange: "Изменить",
    lockerSearch: "Город, улица или название пакомата", lockerEmpty: "Ничего не найдено", lockerLoading: "Загружаем пакоматы…",
    lockerError: "Не удалось загрузить список пакоматов. Попробуйте ещё раз.", lockerRetry: "Повторить",
    lockerTitle: "Выберите пакомат Omniva", lockerCount: "{n} пакоматов в Латвии",
    contacts: "Контакты", contactsHint: "Свяжемся, если нужно уточнить детали",
    name: "Имя", namePh: "Как вас зовут", phone: "Телефон", comment: "Комментарий к заказу", commentPh: "Пожелания, марка авто и т.д.",
    yourOrder: "Ваш заказ", pos: "поз.", empty: "Пока пусто", emptyHint: "Соберите рамку выше и нажмите «Добавить в заказ»",
    topShort: "Сверху", bottomShort: "Снизу", color: "Цвет", edit: "Изменить", remove: "Удалить",
    goods: "Товары", discount: "Скидка за пары", total: "Итого", vat: "Цены включают НДС",
    pay: "Оплатить картой", paying: "Переходим к оплате…",
    secure: "Безопасная оплата через Stripe · Visa, Mastercard, Apple Pay, Google Pay",
    openPay: "Оплата открылась в новой вкладке. Если нет — нажмите здесь",
    testMode: "Онлайн-оплата пока в тестовом режиме — реальные деньги не списываются.",
    errCart: "Добавьте хотя бы одну рамку в заказ", errName: "Укажите имя", errPhone: "Укажите номер телефона",
    errLocker: "Выберите пакомат Omniva", errFill: "Заполните обязательные поля",
    mobileBar: "Оформить заказ · {n} шт. · {total}",
  },
  delivery: {
    omniva: { label: "Пакомат Omniva", description: "Доставка в любой пакомат Omniva в Латвии" },
    pickup: { label: "Самовывоз", description: "Договоримся о месте и времени в Telegram" },
  },
  colors: { white: "Белый", blue: "Синий", pink: "Розовый", red: "Красный" },
  how: {
    label: "03 — Как заказать", title: "Четыре шага до новой рамки",
    steps: [
      ["Соберите рамку", "Напишите текст для нижней части рамки, выберите цвет и количество."],
      ["Оплатите картой", "Безопасная оплата онлайн через Stripe."],
      ["Мы печатаем", "Заказ сразу приходит мастеру — и рамка уходит на 3D-принтер."],
      ["Получите", "В пакомате Omniva или самовывозом."],
    ],
  },
  faq: {
    label: "04 — Вопросы", title: "Частые вопросы", sub: "Не нашли ответ? Напишите нам — контакты ниже.",
    items: [
      ["Чем отличаются две модели?", "Individual number holder — номерная рамка с вашим текстом снизу и выбором цвета текста. Invisible number holder — незаметный держатель без надписей, когда хочется чистого вида."],
      ["Сколько стоит?", "Индивидуальная рамка: 1 шт. — 12 €, 2 шт. — 22 € (скидка 2 € за каждую пару). Невидимые держатели: 15 € за набор из 2 комплектов."],
      ["Почему невидимых держателей 2 комплекта?", "В Латвии номера бывают двух размеров — большие и маленькие. Поэтому в наборе 2 комплекта: один для больших номеров, второй для маленьких. Каждый комплект рассчитан на 2 номера (спереди и сзади)."],
      ["Какой текст можно написать?", "Любой: название клуба, инстаграм, имя или фразу — до 28 символов, текст печатается снизу рамки. Если нужно что-то особенное, напишите в комментарии к заказу."],
      ["Какие цвета текста есть?", "Белый, синий, розовый и красный на чёрной рамке."],
      ["Как работает доставка?", "Отправляем в выбранный пакомат Omniva в Латвии за 3,50 €. Также можно забрать заказ самостоятельно — о месте и времени договоримся."],
      ["Сколько ждать заказ?", "Каждую рамку печатаем под заказ. После оплаты мы свяжемся с вами и назовём точный срок."],
      ["Как проходит оплата?", "Онлайн картой (Visa, Mastercard), а также через Apple Pay / Google Pay, если они доступны на вашем устройстве. Оплата защищена Stripe — данные карты мы не видим."],
    ],
  },
  contacts: { label: "05 — Контакты", title: "Хотите что-то особенное?", sub: "Напишите нам — обсудим идею, текст или оптовый заказ для клуба.", telegram: "Написать в Telegram", order: "Собрать рамку онлайн" },
  catalog: { loading: "Загружаем модели…", error: "Не удалось загрузить модели", retry: "Обновить страницу" },
  success: {
    checking: ["Проверяем оплату…", "Это займёт пару секунд. Не закрывайте страницу."],
    paid: ["Спасибо! Заказ оплачен", "Мы уже получили ваш заказ и скоро начнём печать. Свяжемся с вами, если понадобится уточнить детали."],
    pending: ["Оплата ещё обрабатывается", "Банк пока не подтвердил платёж. Обновите страницу через минуту."],
    failed: ["Оплата не прошла", "Деньги не списаны. Попробуйте оформить заказ ещё раз."],
    missing: ["Заказ не найден", "Ссылка недействительна. Вернитесь на главную и попробуйте снова."],
    order: "Заказ", home: "На главную", again: "Заказать ещё", retry: "Попробовать снова",
  },
  cancel: { title: "Оплата отменена", text: "Деньги не списаны. Ваш заказ сохранён — можно вернуться и оплатить, когда будете готовы.", back: "Вернуться к заказу", home: "На главную" },
  genericError: "Что-то пошло не так. Попробуйте ещё раз.",
  fieldsError: "Проверьте правильность заполнения полей.",
};

const lv = {
  nav: { products: "Modeļi", order: "Konstruktors", how: "Kā pasūtīt", faq: "Jautājumi", contacts: "Kontakti", buy: "Pirkt", build: "Izveidot rāmi", openMenu: "Atvērt izvēlni", language: "Valoda" },
  hero: {
    badge: "RPM 3D PRINT · NUMURZĪMJU RĀMJI",
    title1: "Numurzīmju rāmji",
    title2: "ar jūsu",
    title3: "tekstu",
    sub: "Drukājam ar 3D printeri tieši jūsu auto: jūsu teksts rāmja apakšā, krāsa pēc izvēles. Izveidojiet rāmi minūtes laikā, apmaksājiet ar karti un saņemiet Omniva pakomātā.",
    cta: "Izveidot savu rāmi",
    cta2: "Skatīt modeļus",
    f1: "no 12 €", f1s: "2 gab. — 22 €",
    f2: "Ar karti", f2s: "tiešsaistes maksājums",
    f3: "3,50 €", f3s: "Omniva pakomāts",
    extruder: "EKSTRUDERIS", layer: "SLĀNIS",
    marquee: ["INDIVIDUĀLS TEKSTS", "2 GAB. — 22 €", "3D DRUKA", "BALTS · ZILS · ROZĀ · SARKANS", "OMNIVA PAKOMĀTS", "MAKSĀJUMS AR KARTI", "RPM 3D PRINT"],
  },
  products: {
    label: "01 — Modeļi", title: "Izvēlieties savu variantu",
    sub: "Katru rāmi drukājam pēc pasūtījuma — tieši ar to tekstu, ko jūs ierakstīsiet.",
    badge: "Ar jūsu tekstu", order: "Pasūtīt no {price}", orderFor: "Pasūtīt par {price}", photo: "Foto", preview: "Priekšskatījums",
    pairDeal: "2 gab. — {price}", pairSave: "ietaupi {save}", packNote: "par 2 komplektiem",
    items: {
      individual: { local: "Individuāls numurzīmes rāmis", description: "Jūsu teksts rāmja apakšā, teksta krāsa pēc izvēles. Drukājam pēc pasūtījuma. 1 gab. — 12 €, 2 gab. — 22 €.", features: ["Jūsu teksts rāmja apakšā", "4 teksta krāsas", "Atlaide: 2 gab. par 22 €"] },
      invisible: { local: "Neredzami numurzīmes turētāji — 2 komplekti", description: "Iepakojumā 2 komplekti: viens lielajām numurzīmēm, otrs mazajām — Latvijā numurzīmes ir divos izmēros. Katrs komplekts paredzēts 2 numurzīmēm.", features: ["2 komplekti: lielajām un mazajām numurzīmēm", "Katrs komplekts — 2 numurzīmēm", "Numurs it kā „lidinās”, vienkārša uzstādīšana"] },
    },
  },
  config: {
    label: "02 — Konstruktors", title: "Izveidojiet savu rāmi",
    sub: "Rakstiet tekstu — rāmis mainās uzreiz. Tieši tā mēs to arī izdrukāsim.",
    preview: "Priekšskatījums · live", previewNote: "Priekšskatījums ir shematisks. Gatavā rāmja fonts un proporcijas var nedaudz atšķirties.",
    pcs: "gab.", textColor: "teksts",
    step1: "Modelis", step2: "Teksts uz rāmja", step2hint: "Teksts tiek drukāts zem numura",
    bottom: "Teksts apakšā", bottomPh: "Piemēram: @your_instagram",
    ideas: "Idejas — pieskarieties, lai ievietotu:", ideaList: ["TI CHO APUPEL", "RPM 3D PRINT", "LATVIJA", "RĪGA", "BRAUC DROŠI", "LOW & SLOW", "JDM", "DRIVE SAFE"],
    textError: "Ierakstiet tekstu rāmja apakšai",
    step3: "Teksta krāsa", step4: "Daudzums", step4hint: "Parasti ņem 2 — priekšā un aizmugurē: 22 € 24 € vietā",
    step4Pack: "Komplektu skaits", step4PackHint: "1 iepakojums = 2 komplekti: lielajām un mazajām numurzīmēm, katrs 2 numurzīmēm", packs: "iep.",
    add: "Pievienot pasūtījumam", added: "Pievienots pasūtījumam", maxItems: "Vienā pasūtījumā ne vairāk kā 10 pozīcijas",
    less: "Mazāk", more: "Vairāk",
    holderHidden: "TURĒTĀJS PASLĒPTS AIZ NUMURA",
  },
  checkout: {
    delivery: "Piegāde", free: "Bez maksas",
    locker: "Omniva pakomāts", lockerChoose: "Izvēlēties pakomātu", lockerChange: "Mainīt",
    lockerSearch: "Pilsēta, iela vai pakomāta nosaukums", lockerEmpty: "Nekas nav atrasts", lockerLoading: "Ielādējam pakomātus…",
    lockerError: "Neizdevās ielādēt pakomātu sarakstu. Mēģiniet vēlreiz.", lockerRetry: "Mēģināt vēlreiz",
    lockerTitle: "Izvēlieties Omniva pakomātu", lockerCount: "{n} pakomāti Latvijā",
    contacts: "Kontakti", contactsHint: "Sazināsimies, ja vajadzēs precizēt detaļas",
    name: "Vārds", namePh: "Kā jūs sauc", phone: "Tālrunis", comment: "Komentārs pasūtījumam", commentPh: "Vēlmes, auto marka u.c.",
    yourOrder: "Jūsu pasūtījums", pos: "poz.", empty: "Pagaidām tukšs", emptyHint: "Izveidojiet rāmi augstāk un nospiediet „Pievienot pasūtījumam”",
    topShort: "Augšā", bottomShort: "Apakšā", color: "Krāsa", edit: "Mainīt", remove: "Dzēst",
    goods: "Preces", discount: "Atlaide par pāriem", total: "Kopā", vat: "Cenās iekļauts PVN",
    pay: "Maksāt ar karti", paying: "Pārejam uz apmaksu…",
    secure: "Droša apmaksa ar Stripe · Visa, Mastercard, Apple Pay, Google Pay",
    openPay: "Apmaksa atvērās jaunā cilnē. Ja nē — spiediet šeit",
    testMode: "Tiešsaistes apmaksa pagaidām darbojas testa režīmā — īsta nauda netiek noņemta.",
    errCart: "Pievienojiet pasūtījumam vismaz vienu rāmi", errName: "Norādiet vārdu", errPhone: "Norādiet tālruņa numuru",
    errLocker: "Izvēlieties Omniva pakomātu", errFill: "Aizpildiet obligātos laukus",
    mobileBar: "Noformēt pasūtījumu · {n} gab. · {total}",
  },
  delivery: {
    omniva: { label: "Omniva pakomāts", description: "Piegāde uz jebkuru Omniva pakomātu Latvijā" },
    pickup: { label: "Pašizņemšana", description: "Par vietu un laiku vienosimies Telegram" },
  },
  colors: { white: "Balts", blue: "Zils", pink: "Rozā", red: "Sarkans" },
  how: {
    label: "03 — Kā pasūtīt", title: "Četri soļi līdz jaunam rāmim",
    steps: [
      ["Izveidojiet rāmi", "Ierakstiet tekstu rāmja apakšai, izvēlieties krāsu un daudzumu."],
      ["Apmaksājiet ar karti", "Droša tiešsaistes apmaksa ar Stripe."],
      ["Mēs drukājam", "Pasūtījums uzreiz nonāk pie meistara, un rāmis tiek drukāts ar 3D printeri."],
      ["Saņemiet", "Omniva pakomātā vai pašizņemšanā."],
    ],
  },
  faq: {
    label: "04 — Jautājumi", title: "Biežākie jautājumi", sub: "Neatradāt atbildi? Rakstiet mums — kontakti zemāk.",
    items: [
      ["Ar ko atšķiras abi modeļi?", "Individual number holder — numurzīmes rāmis ar jūsu tekstu apakšā un teksta krāsas izvēli. Invisible number holder — neuzkrītošs turētājs bez uzrakstiem, ja gribas tīru izskatu."],
      ["Cik tas maksā?", "Individuālais rāmis: 1 gab. — 12 €, 2 gab. — 22 € (2 € atlaide par katru pāri). Neredzamie turētāji: 15 € par iepakojumu ar 2 komplektiem."],
      ["Kāpēc neredzamie turētāji ir 2 komplektos?", "Latvijā numurzīmes ir divos izmēros — lielās un mazās. Tāpēc iepakojumā ir 2 komplekti: viens lielajām numurzīmēm, otrs mazajām. Katrs komplekts paredzēts 2 numurzīmēm (priekšā un aizmugurē)."],
      ["Kādu tekstu var uzrakstīt?", "Jebkuru: kluba nosaukumu, Instagram, vārdu vai frāzi — līdz 28 simboliem, teksts tiek drukāts rāmja apakšā. Ja vajag ko īpašu, uzrakstiet komentārā pie pasūtījuma."],
      ["Kādas teksta krāsas ir pieejamas?", "Balta, zila, rozā un sarkana uz melna rāmja."],
      ["Kā notiek piegāde?", "Sūtām uz izvēlēto Omniva pakomātu Latvijā par 3,50 €. Pasūtījumu var arī izņemt pašam — par vietu un laiku vienosimies."],
      ["Cik ilgi jāgaida pasūtījums?", "Katru rāmi drukājam pēc pasūtījuma. Pēc apmaksas sazināsimies ar jums un nosauksim precīzu termiņu."],
      ["Kā notiek apmaksa?", "Tiešsaistē ar karti (Visa, Mastercard), kā arī ar Apple Pay / Google Pay, ja tie pieejami jūsu ierīcē. Maksājumu aizsargā Stripe — kartes datus mēs neredzam."],
    ],
  },
  contacts: { label: "05 — Kontakti", title: "Gribat ko īpašu?", sub: "Rakstiet mums — apspriedīsim ideju, tekstu vai vairumpasūtījumu klubam.", telegram: "Rakstīt Telegram", order: "Izveidot rāmi tiešsaistē" },
  catalog: { loading: "Ielādējam modeļus…", error: "Neizdevās ielādēt modeļus", retry: "Atsvaidzināt lapu" },
  success: {
    checking: ["Pārbaudām apmaksu…", "Tas aizņems pāris sekundes. Neaizveriet lapu."],
    paid: ["Paldies! Pasūtījums apmaksāts", "Mēs jau saņēmām jūsu pasūtījumu un drīz sāksim drukāt. Sazināsimies, ja vajadzēs precizēt detaļas."],
    pending: ["Maksājums vēl tiek apstrādāts", "Banka vēl nav apstiprinājusi maksājumu. Atsvaidziniet lapu pēc minūtes."],
    failed: ["Maksājums neizdevās", "Nauda netika noņemta. Mēģiniet noformēt pasūtījumu vēlreiz."],
    missing: ["Pasūtījums nav atrasts", "Saite nav derīga. Atgriezieties sākumlapā un mēģiniet vēlreiz."],
    order: "Pasūtījums", home: "Uz sākumlapu", again: "Pasūtīt vēl", retry: "Mēģināt vēlreiz",
  },
  cancel: { title: "Apmaksa atcelta", text: "Nauda netika noņemta. Jūsu pasūtījums ir saglabāts — varat atgriezties un apmaksāt, kad būsiet gatavi.", back: "Atgriezties pie pasūtījuma", home: "Uz sākumlapu" },
  genericError: "Kaut kas nogāja greizi. Mēģiniet vēlreiz.",
  fieldsError: "Pārbaudiet, vai lauki aizpildīti pareizi.",
};

const en = {
  nav: { products: "Models", order: "Builder", how: "How to order", faq: "FAQ", contacts: "Contacts", buy: "Buy", build: "Build a frame", openMenu: "Open menu", language: "Language" },
  hero: {
    badge: "RPM 3D PRINT · LICENSE PLATE FRAMES",
    title1: "License plate frames",
    title2: "with your",
    title3: "text",
    sub: "3D-printed for your car: your text on the bottom of the frame, colour of your choice. Build your frame in a minute, pay by card and pick it up from an Omniva parcel locker.",
    cta: "Build your frame",
    cta2: "View models",
    f1: "from 12 €", f1s: "2 pcs — 22 €",
    f2: "By card", f2s: "online payment",
    f3: "3.50 €", f3s: "Omniva parcel locker",
    extruder: "EXTRUDER", layer: "LAYER",
    marquee: ["CUSTOM TEXT", "2 PCS — 22 €", "3D PRINTED", "WHITE · BLUE · PINK · RED", "OMNIVA PARCEL LOCKER", "CARD PAYMENT", "RPM 3D PRINT"],
  },
  products: {
    label: "01 — Models", title: "Choose your option",
    sub: "Every frame is printed to order — with exactly the text you write.",
    badge: "With your text", order: "Order from {price}", orderFor: "Order for {price}", photo: "Photo", preview: "Preview",
    pairDeal: "2 pcs — {price}", pairSave: "save {save}", packNote: "for 2 sets",
    items: {
      individual: { local: "Custom license plate frame", description: "Your text on the bottom of the frame, text colour of your choice. Printed to order. 1 pc — 12 €, 2 pcs — 22 €.", features: ["Your text on the bottom", "4 text colours", "Deal: 2 pcs for 22 €"] },
      invisible: { local: "Invisible plate holders — 2 sets", description: "Each pack has 2 sets: one for large plates and one for small plates — Latvian plates come in two sizes. Each set fits 2 plates.", features: ["2 sets: for large and for small plates", "Each set fits 2 plates", "The plate seems to float, easy installation"] },
    },
  },
  config: {
    label: "02 — Builder", title: "Build your frame",
    sub: "Type your text — the frame updates instantly. That's exactly how we'll print it.",
    preview: "Preview · live", previewNote: "The preview is schematic. Font and proportions on the finished frame may differ slightly.",
    pcs: "pcs", textColor: "text",
    step1: "Model", step2: "Text on the frame", step2hint: "The text is printed below the plate",
    bottom: "Bottom text", bottomPh: "e.g. @your_instagram",
    ideas: "Ideas — tap to use:", ideaList: ["TI CHO APUPEL", "RPM 3D PRINT", "LATVIA", "RIGA", "DRIVE SAFE", "LOW & SLOW", "JDM", "STANCE NATION"],
    textError: "Enter the text for the bottom of the frame",
    step3: "Text colour", step4: "Quantity", step4hint: "Most people take 2 — front and rear: 22 € instead of 24 €",
    step4Pack: "Number of packs", step4PackHint: "1 pack = 2 sets: for large and for small plates, each set fits 2 plates", packs: "packs",
    add: "Add to order", added: "Added to order", maxItems: "Maximum 10 items per order",
    less: "Less", more: "More",
    holderHidden: "HOLDER HIDDEN BEHIND THE PLATE",
  },
  checkout: {
    delivery: "Delivery", free: "Free",
    locker: "Omniva parcel locker", lockerChoose: "Choose a parcel locker", lockerChange: "Change",
    lockerSearch: "City, street or locker name", lockerEmpty: "Nothing found", lockerLoading: "Loading parcel lockers…",
    lockerError: "Couldn't load the parcel locker list. Please try again.", lockerRetry: "Retry",
    lockerTitle: "Choose an Omniva parcel locker", lockerCount: "{n} parcel lockers in Latvia",
    contacts: "Contacts", contactsHint: "We'll get in touch if we need to clarify details",
    name: "Name", namePh: "Your name", phone: "Phone", comment: "Order comment", commentPh: "Wishes, car make, etc.",
    yourOrder: "Your order", pos: "items", empty: "Nothing here yet", emptyHint: "Build a frame above and tap “Add to order”",
    topShort: "Top", bottomShort: "Bottom", color: "Colour", edit: "Edit", remove: "Remove",
    goods: "Items", discount: "Pair discount", total: "Total", vat: "Prices include VAT",
    pay: "Pay by card", paying: "Redirecting to payment…",
    secure: "Secure payment by Stripe · Visa, Mastercard, Apple Pay, Google Pay",
    openPay: "Payment opened in a new tab. If not, tap here",
    testMode: "Online payment is in test mode for now — no real money is charged.",
    errCart: "Add at least one frame to your order", errName: "Enter your name", errPhone: "Enter your phone number",
    errLocker: "Choose an Omniva parcel locker", errFill: "Please fill in the required fields",
    mobileBar: "Checkout · {n} pcs · {total}",
  },
  delivery: {
    omniva: { label: "Omniva parcel locker", description: "Delivery to any Omniva parcel locker in Latvia" },
    pickup: { label: "Pickup", description: "We'll agree on the place and time via Telegram" },
  },
  colors: { white: "White", blue: "Blue", pink: "Pink", red: "Red" },
  how: {
    label: "03 — How to order", title: "Four steps to your new frame",
    steps: [
      ["Build your frame", "Write the text for the bottom of the frame, pick a colour and quantity."],
      ["Pay by card", "Secure online payment by Stripe."],
      ["We print", "Your order goes straight to the maker and onto the 3D printer."],
      ["Pick it up", "From an Omniva parcel locker or in person."],
    ],
  },
  faq: {
    label: "04 — FAQ", title: "Frequently asked questions", sub: "Didn't find an answer? Message us — contacts below.",
    items: [
      ["What's the difference between the two models?", "Individual number holder is a plate frame with your own text on the bottom and a choice of text colour. Invisible number holder is a discreet holder without lettering for a clean look."],
      ["How much does it cost?", "Custom frame: 1 pc — 12 €, 2 pcs — 22 € (2 € off every pair). Invisible holders: 15 € per pack of 2 sets."],
      ["Why do invisible holders come in 2 sets?", "Latvian plates come in two sizes — large and small. So each pack contains 2 sets: one for large plates and one for small plates. Each set fits 2 plates (front and rear)."],
      ["What text can I write?", "Anything: club name, Instagram, a name or a phrase — up to 28 characters, printed on the bottom of the frame. If you need something special, add it in the order comment."],
      ["Which text colours are available?", "White, blue, pink and red on a black frame."],
      ["How does delivery work?", "We ship to your chosen Omniva parcel locker in Latvia for 3.50 €. You can also pick up the order in person — we'll agree on the place and time."],
      ["How long does it take?", "Every frame is printed to order. After payment we'll contact you with the exact timing."],
      ["How do I pay?", "Online by card (Visa, Mastercard), or Apple Pay / Google Pay if available on your device. Payments are protected by Stripe — we never see your card details."],
    ],
  },
  contacts: { label: "05 — Contacts", title: "Want something special?", sub: "Message us — let's discuss your idea, text or a bulk order for your club.", telegram: "Message on Telegram", order: "Build a frame online" },
  catalog: { loading: "Loading models…", error: "Couldn't load models", retry: "Reload page" },
  success: {
    checking: ["Checking payment…", "This takes a couple of seconds. Please keep this page open."],
    paid: ["Thank you! Your order is paid", "We've received your order and will start printing soon. We'll contact you if we need to clarify anything."],
    pending: ["Payment is still processing", "The bank hasn't confirmed the payment yet. Refresh the page in a minute."],
    failed: ["Payment failed", "You were not charged. Please try placing the order again."],
    missing: ["Order not found", "This link is invalid. Go back to the home page and try again."],
    order: "Order", home: "Home", again: "Order more", retry: "Try again",
  },
  cancel: { title: "Payment cancelled", text: "You were not charged. Your order is saved — come back and pay whenever you're ready.", back: "Back to order", home: "Home" },
  genericError: "Something went wrong. Please try again.",
  fieldsError: "Please check the fields.",
};

export const DICTS = { ru, lv, en };
const LOCALES = { ru: "ru-RU", lv: "lv-LV", en: "en-IE" };
const KEY = "rpm_lang_v2";

const detect = () => {
  // Latvian is the default; visitors switch to EN / RU in the header
  const saved = localStorage.getItem(KEY);
  if (saved && DICTS[saved]) return saved;
  return "lv";
};

const get = (obj, path) => path.split(".").reduce((o, k) => (o == null ? o : o[k]), obj);

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detect);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    if (!DICTS[l]) return;
    localStorage.setItem(KEY, l);
    setLangState(l);
  }, []);

  const t = useCallback(
    (path, vars) => {
      let v = get(DICTS[lang], path);
      if (v === undefined) v = get(ru, path);
      if (v === undefined) return path;
      if (typeof v === "string" && vars) {
        return Object.entries(vars).reduce((s, [k, val]) => s.replaceAll(`{${k}}`, val), v);
      }
      return v;
    },
    [lang]
  );

  const money = useCallback(
    (v) => new Intl.NumberFormat(LOCALES[lang], { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(v || 0),
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t, money }), [lang, setLang, t, money]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useI18n = () => useContext(LangContext);
